import Navbar from '@/components/Navbar';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar onBookNow={() => {}} />
      
      {/* Page Header */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Get In <span className="gold-gradient">Touch</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Contact Calgary's premier delivery and hauling service
          </p>
        </div>
      </section>

      <ContactForm />
      <Footer />
    </div>
  );
};

export default ContactPage;
